
import DeleteConfirmDialog from '@/components/common/DeleteConfirmDialog.vue'
import { DELETE_SAVED_SEARCH_CONDITION, RENAME_SAVED_SEARCH_CONDITION } from '@/store/actions'
import errorHandler from '@/utils/errorHandler'
import { ISavedSearchCondition } from '@/utils/types'
import { openMessage } from '@/utils/utils'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'SavedSearchConditionDialog',
  components: { DeleteConfirmDialog },
  emits: ['update:modelValue', 'apply'],
})
export default class SavedSearchConditionDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly modelValue!: boolean
  @Prop({ type: Array, default: () => [] }) readonly savedSearchConditions!: ISavedSearchCondition[]
  @Prop({ type: String, default: null }) readonly matchedConditionId!: string | null

  isShowRenameModal = false
  isShowDeleteModal = false
  isRenaming = false
  isDeleting = false
  renamingConditionId: string | null = null
  renamingConditionName = ''
  deletingConditionId: string | null = null

  get isRenameDuplicate(): boolean {
    const trimmed = this.renamingConditionName.trim().toLowerCase()
    return (
      !!trimmed &&
      this.savedSearchConditions.some(
        (s) => s.id !== this.renamingConditionId && s.name.trim().toLowerCase() === trimmed
      )
    )
  }

  get isRenameDisabled(): boolean {
    return !this.renamingConditionName.trim() || !this.renamingConditionId || this.isRenameDuplicate || this.isRenaming
  }

  applyCondition(condition: ISavedSearchCondition) {
    this.$emit('apply', condition)
  }

  openRenameModal(condition: ISavedSearchCondition) {
    this.renamingConditionId = condition.id
    this.renamingConditionName = condition.name
    this.isShowRenameModal = true
  }

  async confirmRename() {
    if (this.isRenameDisabled) return
    this.isRenaming = true
    try {
      await this.$store.dispatch(RENAME_SAVED_SEARCH_CONDITION, {
        id: this.renamingConditionId,
        name: this.renamingConditionName.trim(),
      })
      openMessage(this.$t('rename_saved_search_condition_success'), 'success')
    } catch (e) {
      errorHandler(e)
    } finally {
      this.isRenaming = false
      this.isShowRenameModal = false
      this.renamingConditionId = null
      this.renamingConditionName = ''
    }
  }

  openDeleteModal(id: string) {
    this.deletingConditionId = id
    this.isShowDeleteModal = true
  }

  async confirmDelete() {
    if (!this.deletingConditionId) return
    this.isDeleting = true
    try {
      await this.$store.dispatch(DELETE_SAVED_SEARCH_CONDITION, this.deletingConditionId)
      openMessage(this.$t('delete_saved_search_condition_success'), 'success')
    } catch (e) {
      errorHandler(e)
    } finally {
      this.isDeleting = false
      this.isShowDeleteModal = false
      this.deletingConditionId = null
    }
  }
}
